export { default, getServerSideProps } from 'modules/marketplace/catalog/pages/HomePage'
